let efSound = (src, options) => {
    let efAudio = new Audio;
    if (options && options.globalAudio) window.globalAudio = efAudio;
    let efPlay = function () {
        efAudio.removeEventListener('loadeddata', efPlay);
        if (options && options.paused) efAudio.pause();
        else efAudio.play();
    };
    efAudio.src = src;
    efAudio.addEventListener('loadeddata', efPlay);
    efAudio.load();

    return efAudio;
};

export default efSound;